import { createMentionUrl } from '@aline/common';

export function createDocumentMentionMarkdown({
  displayText,
  documentId,
}: {
  displayText: string;
  documentId: string;
}) {
  const mentionUrl = createMentionUrl('document', documentId);
  return `[@${escapeMarkdownLinkLabel(displayText || 'Untitled document')}](${mentionUrl})`;
}

export function createUserMentionMarkdown({
  displayText,
  userId,
}: {
  displayText: string;
  userId: string;
}) {
  const mentionUrl = createMentionUrl('user', userId);
  return `[@${escapeMarkdownLinkLabel(displayText || 'Unknown user')}](${mentionUrl})`;
}

export function createPlaybookMentionMarkdown({
  displayText,
  playbookId,
}: {
  displayText: string;
  playbookId: string;
}) {
  const mentionUrl = createMentionUrl('playbook', playbookId);
  return `[@${escapeMarkdownLinkLabel(displayText || 'Untitled playbook')}](${mentionUrl})`;
}

function escapeMarkdownLinkLabel(label: string) {
  return label.replaceAll('\\', '\\\\').replaceAll('[', '\\[').replaceAll(']', '\\]');
}
